import React from 'react'

function Footer() {
  return (
    <div className="footer">
    <p>
      Click on a
      <img
        className="bird-icon"
        src="https://cdn-icons-png.flaticon.com/512/8845/8845053.png"
        alt="bird marker icon"
      ></img>
      to listen to a recording...{" "}
    </p>
  </div>
  )
}

export default Footer